define('models/campaignMargin',["T1", "Backbone", "T1Model"], function (T1, Backbone, T1Model) {
  T1.Models.CampaignMargin = T1Model.extend({});
  return T1.Models.CampaignMargin;
});
